module.exports = __webpack_public_path__ + "static/media/ellipsis.90091ac1.svg";